import type { SearchProduct } from '../components/SearchPreview/types';

export const mapSearchPreviewProductToShadePicker = (product: SearchProduct) =>
  product.shades?.map((shade) => ({
    code: shade.productCode,
    name: shade.name ?? '',
    price: {
      currentFormatted: shade.price.currentFormatted,
    },
    shade,
  })) ?? [];
